<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import SearchDropdown from "../Form/Fields/Dropdown/SearchDropdown.svelte";
    import type { IDropdownItem } from "../../services/DTO/dropdown-item";

  export let placeholder: string = "";
  export let required: boolean = false;
  export let disabled: boolean = false;
  export let clearVisible: boolean = false;
  export let filterVisible: boolean = true;
  export let name: string = "Stato";
  export let value: string = null;
  export let small: boolean = false;

  const dispatch = createEventDispatcher();

  let items: IDropdownItem[] = [];

  function onFilter(event: CustomEvent) {
    let filter: string = event.detail;
    search(filter);
  }

  async function search(filter: string) { 
    let values =  ['In Erogazione', 'Avviato', 'Rendicontato', 'Da rendicontare', 'Verificato', 'Chiuso' ];
    items = values.map(x => {
      return {oid: x, label: x} as IDropdownItem
    } );
  }





  function onSelect(event: CustomEvent) {
    if (event == null) {
      dispatch("clear");
    } else {
      dispatch("select", event.detail);
    }
  }

  onMount(() => search(""));
</script>

<SearchDropdown
  {placeholder}
  {required}
  {disabled}
  {clearVisible}
  {filterVisible}
  {name}
  {items}
  {small}
  bind:value
  on:filter={onFilter}
  on:select={onSelect}
/>
